import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconWifiComponent } from "./med-icon-wifi.component";

@NgModule({
  declarations: [
    MedIconWifiComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconWifiComponent,
  ],
})
export class MedIconWifiModule { }
